export class States {
	label: string;
	stateProvinces: any;
}

export class Provinces {
	label: string;
	stateProvinces: any;
}

export class StateProvinces {
	canadianProvinces = new Provinces();
	states = new States();
}
